import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    info: {
      name: "",
      phone: "",
      telephone: "",
      showname1: "",
      nid1: 0,
      showname2: "",
      nid2: 0,
      showname3: "",
      nid3: 0,
      showname4: "",
      nid4: 0,
      logoUrl: "",
      factoryUrl: "",
      contactUrl: "",
      postalCode: "",
      qq: "",
      address: "",
      email: "",
    },
    item: {
      imageId: "",
      content: "",
      nid: 1,
    },
    myactive: "1",
    activeIndex: "1",
  },
  getters: {
    getInfo(state) {
      return state.info;
    },
    getItem(state) {
      return state.item;
    },
    getActiveIndex(state) {
      return state.activeIndex;
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js